import { render, staticRenderFns } from "./tips.vue?vue&type=template&id=4b9e5b9e&scoped=true&"
import script from "./tips.vue?vue&type=script&lang=js&"
export * from "./tips.vue?vue&type=script&lang=js&"
import style0 from "./tips.vue?vue&type=style&index=0&id=4b9e5b9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9e5b9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b9e5b9e')) {
      api.createRecord('4b9e5b9e', component.options)
    } else {
      api.reload('4b9e5b9e', component.options)
    }
    module.hot.accept("./tips.vue?vue&type=template&id=4b9e5b9e&scoped=true&", function () {
      api.rerender('4b9e5b9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/uiKit/tips.vue"
export default component.exports